import { createSlice } from "@reduxjs/toolkit";

interface UserState {
  mobile: string;
  actionType: string;
  userImage: string;
  searchString: string;
}

const userInitialState: UserState = {
  mobile: "",
  actionType: "",
  userImage: "",
  searchString: "",
};

const userSlice = createSlice({
  name: "user",
  initialState: userInitialState,
  reducers: {
    setUserData: (state, action: any) => {
      const { mobile, actionType, username, useremail, city_name } =
        action.payload;
      Object.assign(state, {
        mobile,
        actionType,
        username,
        useremail,
        city_name,
      });
      return state;
    },
    setUserImage: (state, action: any) => {
      state.userImage = action.payload;
    },
    setSearchString: (state, action: any) => {
      state.searchString = action.payload;
    },
  },
});

export const { setUserData, setUserImage, setSearchString } = userSlice.actions;

export { userSlice as UserSlice };
